export const QuestionOpinometroActionTypes = {
  API_RESPONSE_SUCCESS: '@@question-opinometro/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@question-opinometro/API_RESPONSE_ERROR',

  GET_QUESTION_OPINOMETRO: '@@question-opinometro/GET_QUESTION_OPINOMETRO',
  LIST_QUESTION_OPINOMETROS: '@@question-opinometro/LIST_QUESTION_OPINOMETROS',
  ADD_QUESTION_OPINOMETRO: '@@question-opinometro/ADD_QUESTION_OPINOMETRO',
  UPDATE_QUESTION_OPINOMETRO: '@@question-opinometro/UPDATE_QUESTION_OPINOMETRO',
  DELETE_QUESTION_OPINOMETRO: '@@question-opinometro/DELETE_QUESTION_OPINOMETRO',

  RESET: '@@question-opinometro/RESET'
}
